import React, { Fragment } from 'react';
import classnames from 'classnames';

import Illustration from 'foundations/Illustrations/Illustration';

import styles from './IllustrationsUsage.css';

const Usage = () => (
  <Fragment>
    <section>
      <article className="flex-row">
        <div className="left">
          <h1 className="h1 page-title">Illustrations are a continuation of the visual identity for Airtel’s digital strategy.</h1>
        </div>
        <div className="right copy-content">
          <p>Following the same principles outlined for the iconography, the illustrations were designed to be more explanatory, providing more detail and an explicit message which requires a larger scale. </p>
          <p>There’s always a main object in the representation that is highlighted with a dotted shadow — this intends to reinforce the message supported by the illustration.</p>
        </div>
      </article>
    </section>

    <section className="bg-grey flex-grow-1 with-padding">
      <article className="flex-row flex-justify-end flex-wrap">
        <div className="right">
          <h2 className="h2 page-subtitle grey">Illustration Family</h2>
        </div>
        <div className="flex-basis-100">
          <div className={classnames('flex', 'flex-justify-center', 'flex-align-end')}>
            <p className={classnames(styles.sizeLabel, 'list')}>120px</p>
            <Illustration name={'organization'} size={'120'} className={styles.illustrationMargin} />
            <p className={classnames(styles.sizeLabel, 'list')}>180px</p>
            <Illustration name={'organization'} size={'180'} className={styles.illustrationMargin} />
            <p className={classnames(styles.sizeLabel, 'list')}>240px</p>
            <Illustration name={'organization'} size={'240'} className={styles.illustrationMargin} />
          </div>
        </div>
      </article>
    </section>
  </Fragment>
);

export default Usage;



// WEBPACK FOOTER //
// ./src/containers/foundations/Illustrations/IllustrationsUsage/IllustrationsUsage.js